/* eslint-disable */

import Image from "next/image";

import whatsAppIcon from "@/assets/icons/Whatsapp_logo.svg";
import styles from "@/styles/digital-gold/giftStatus.module.css";
import moment from "moment";
import { useBuyRedirectStore } from "@/api/digital-gold/store/buyGoldRedirectionStore";
import { BuyStepName } from "@/utils/constants/digital-gold";
import { useBackButton } from "@/common/hooks/useBackButton";

const GiftStatusTrack = ({ orderStatusTimelineData }: any) => {
  /* activeStatus: 0/1/2  which maps to "default/success/failed" colors */

  // default 0 - dot, dot
  // completed 1- completed, dot
  // failed 2- failed, failed
  const [setBuyStep] = useBuyRedirectStore((state) => [state.setBuyStep]);
  const getOrderStatusType = (activeStatus: number) => {
    switch (activeStatus) {
      case 0:
        return "dot";
      case 1:
        return "completed";
      case 2:
        return "failed";
      default:
        break;
    }
  };

  const getOrderStatusIcon = (activeStatus: number) => {
    switch (activeStatus) {
      case 0:
        return "dot";
      case 1:
        return "dot";
      case 2:
        return "failed";
      default:
        break;
    }
  };
  const handleBackButton = () =>{
    return (
      setBuyStep(BuyStepName.buyLanding)
    )
  }
  useBackButton(handleBackButton)
  return (
    <>
      {/* <div className="gift_status">
        <div className="d-flex">
          <Image 
style={{ color: undefined }} src={SuccessTick} alt="success" className="h-50" />
          <div className="ml-1">
            <p className="loanCard__title with-desc text--bold text--black">
              Gold Sent
            </p>
            <p>Sat,06 June'23</p>
          </div>
        </div>
        <Image 
style={{ color: undefined }} src={greenLine} alt="green line" />
        <div className="d-flex">
          <Image 
style={{ color: undefined }} src={currentStatus} alt="current status" />
          <div className="ml-1">
            <p className="loanCard__title with-desc text--bold text--black">
              Gold Received
            </p>
            <p>Tue,09 June'23</p>
          </div>
        </div>
      </div> */}

      <div className={`${styles.stepper}`}>
        <ul className={`${styles.wizard}`}>
          {orderStatusTimelineData?.map((eachStatus: any, index: number) => {
            return (
              <li
                key={index}
                className={`${
                  styles[`${getOrderStatusType(eachStatus?.activeStatus)}`]
                }`}
              >
                <span
                  className={`${
                    styles[`${getOrderStatusIcon(eachStatus?.activeStatus)}`]
                  }`}
                ></span>
                <div 
                // style={{ marginLeft: "24px" }}
                className="ml-4"
                >
                  <p className={`${styles.status_text}`}>
                    {eachStatus?.placeholderText}
                  </p>
                  <p className={`${styles.status_data}`}>
                    {/* {eachStatus?.timestamp} */}
                  {eachStatus?.activeStatus !=2 ?  eachStatus?.timestamp !== "Status yet to be updated" ?  moment(eachStatus?.timestamp).format("ddd, DD MMM 'YY") : eachStatus?.timestamp : <br/>}
                  </p> 
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Reference : Timeline Tracker design  */}
      {/* <div className={`${styles.stepper}`}>
        <ul className={`${styles.wizard}`}>
          <li className={`${styles.completed}`}>
            <span className={`${styles.dot}`}></span>
            <div className="ml-3">
              <p className={`${styles.status_text}`}>
                Gold Gifted to Recipient
              </p>
              <p className={`${styles.status_data}`}>Sat,06 June 23</p>
            </div>
          </li>

          <li className={`${styles.completed}`}>
            <span className={`${styles.dot}`}></span>
            <div className="ml-3">
              <p className={`${styles.status_text}`}>SMS Sent to Recipient </p>
              <p className={`${styles.status_data}`}>Tue,09 June 23</p>
            </div>{" "}
          </li>

          <li className={`${styles.failed}`}>
            <span className={`${styles.failed}`}></span>
            <div className="ml-4">
              <p className={`${styles.status_text}`}>
                Gold Claimed by Recipient
              </p>
              <p className={`${styles.status_data}`}>
                Status yet to be updated
              </p>
            </div>{" "}
          </li>

          <li className={`${styles.dot}`}>
            <span className={`${styles.dot}`}></span>
            <div className="ml-3">
              <p className={`${styles.status_text}`}>
                Gold Credited to Recipent
              </p>
              <p className={`${styles.status_data}`}>
                Status yet to be updated
              </p>
            </div>{" "}
          </li>
        </ul>
      </div> */}

      {/* Show below button on a condition */}
      {/* <button
        className={`custom__button custom__button--dark text--bold whatsapp_button ${styles.reminder_button}`}
      >
        {" "}
        <Image 
style={{ color: undefined }}
          src={whatsAppIcon}
          alt="whatsapp"
          className="mr-1"
          width={14}
          height={14}
        />{" "}
        Send Reminder
      </button> */}
    </>
  );
};

export default GiftStatusTrack;
